import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Image, Mail, MapPin } from 'lucide-react';
import { TermsModal } from '@/components/auth/TermsModal';

export function Footer() {
  const [showTermsModal, setShowTermsModal] = useState(false);
  const currentYear = new Date().getFullYear();
  const [, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleScrollTo = (sectionId: string) => {
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }; 

  return (
    <>
      <footer className="bg-gray-900 text-gray-300">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* 회사 정보 */}
            <div className="col-span-1 md:col-span-2">
              <div className="flex items-center gap-2 mb-4">
                <img src="/favicon-32x32.png" alt="ALT Generation Logo" className="h-8 w-8" />
                <span className="text-xl font-bold text-white">ALT Generation</span>
              </div>
              <p className="text-sm mb-4 text-gray-400">
                AI 기반 이미지 ALT 텍스트 자동 생성 솔루션으로<br />
                웹 접근성을 향상하고 SEO를 최적화합니다.
              </p>
              <div className="space-y-2">
                <div className="flex items-center gap-2 text-sm">
                  <MapPin className="h-4 w-4 text-gray-500" />
                  <span>서울 중구 다산로 106 (신당동, 한두빌딩) 5층</span>
                </div>
                <div className="flex items-center gap-2 text-sm">
                  <Mail className="h-4 w-4 text-gray-500" />
                  <span>ibjun77@gmail.com</span>
                </div>
              </div>
            </div>

            {/* 서비스 링크 */}
            <div>
              <h3 className="text-white font-semibold mb-4">서비스</h3>
              <ul className="space-y-2">
                <li>
                  <button 
                    onClick={() => handleScrollTo('features')}
                    className="text-sm hover:text-primary transition-colors"
                  >
                    주요 기능
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => handleScrollTo('pricing')}
                    className="text-sm hover:text-primary transition-colors"
                  >
                    요금제
                  </button>
                </li>
                <li>
                  <Link to="/signup" className="text-sm hover:text-primary transition-colors">
                    무료 시작하기
                  </Link>
                </li>
                <li>
                  <Link to="/login" className="text-sm hover:text-primary transition-colors">
                    로그인
                  </Link>
                </li>
              </ul>
            </div>

            {/* 회사 */}
            <div>
              <h3 className="text-white font-semibold mb-4">회사</h3>
              <ul className="space-y-2">
                <li>
                  <button 
                    onClick={() => {
                      setMobileMenuOpen(false);
                      handleScrollTo('about');
                    }}
                    className="text-sm hover:text-primary transition-colors"
                  >
                    회사 소개
                  </button>
                </li>
                <li>
                  <a href="mailto:ibjun77@gmail.com" className="text-sm hover:text-primary transition-colors">
                    문의하기
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* 하단 영역 */}
          <div className="border-t border-gray-800 mt-8 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              {/* 회사 정보 */}
              <div className="text-xs text-gray-500 text-center md:text-left">
                <p>상호명: (주)지호아이앤씨 | 대표이사: 최정윤 | 사업자등록번호: 849-81-00345</p>
                {/* <p className="mt-1">통신판매업신고번호: 경주 제03-34호</p> */}
              </div>

              {/* 법적 링크 */}
              <div className="flex gap-4">
                <button
                  onClick={() => setShowTermsModal(true)}
                  className="text-xs text-gray-400 hover:text-primary transition-colors underline"
                >
                  이용약관
                </button>
                <Link
                  to="/privacy"
                  className="text-xs text-gray-400 hover:text-primary transition-colors underline font-semibold"
                >
                  개인정보처리방침
                </Link>
              </div>
            </div>

            {/* 저작권 */}
            <div className="mt-4 text-center">
              <p className="text-xs text-gray-500">
                © {currentYear} ALT Generation. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* 약관 모달 */}
      {showTermsModal && <TermsModal open={showTermsModal} onOpenChange={setShowTermsModal} />}
    </>
  );
}
